import { useEffect, useState } from "react";

const KEY = "lastJobId";
const EVENT = "lastjob-change";

export const getLastJobId = () => localStorage.getItem(KEY);

export const setLastJobId = (id) => {
  localStorage.setItem(KEY, id);
  addToHistory(id);
  window.dispatchEvent(new Event(EVENT));
};

export const clearLastJobId = () => {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event(EVENT));
};

export const useLastJobId = () => {
  const [id, setId] = useState(getLastJobId);
  useEffect(() => {
    const sync = () => setId(getLastJobId());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);
  return id;
};

const HISTORY_KEY = "jobHistory";
const MAX_HISTORY = 30;

export const getHistory = () => {
  try {
    return JSON.parse(localStorage.getItem(HISTORY_KEY)) || [];
  } catch {
    return [];
  }
};

export const addToHistory = (id) => {
  const rest = getHistory().filter((h) => h.id !== id);
  localStorage.setItem(HISTORY_KEY, JSON.stringify([{ id, addedAt: Date.now() }, ...rest].slice(0, MAX_HISTORY)));
};

export const removeFromHistory = (ids) => {
  const drop = new Set(ids);
  localStorage.setItem(HISTORY_KEY, JSON.stringify(getHistory().filter((h) => !drop.has(h.id))));
  if (drop.has(getLastJobId())) clearLastJobId();
};
